<template>
    <div>
        <div id="notifications"></div>
        <router-view/>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {EventBus} from "./main";
    var frc = Vue.prototype.$frc;


    export default {
        created() {
            EventBus.$on("wardUpdated", this.wardChosen);
        },
        methods:{
            wardChosen: function(ward) {
                Vue.setCurrentWard(ward);
                Vue.notifyInfo({
                    message: this.$t("wardChangedTo") + " <b> " + Vue.prototype.$currentWard.displayName + "</b>"
                });
            }
        }
    }
</script>

<style>
    @import url(~@fortawesome/fontawesome-free/css/all.min.css);
    @import "assets/css/w3.css";
    @import "assets/css/style.css";
</style>
